import * as React from 'react';

import './SchedulerMessagePanel.pcss';

interface Props {
  content:any;
  onOKAction:()=>void;
  onCancelAction?:()=>void;
  buttonLabelOK?:string;
  buttonLabelCancel?:string;
  disableOk?:boolean;
  okDisabledWarning?:string;
}

export const ScheduleMessagePanel = (props:Props) => {

  function handleOk() {
    if(!props.disableOk) {
      props.onOKAction();
    } else {
      alert(props.okDisabledWarning?props.okDisabledWarning:(props.buttonLabelOK?props.buttonLabelOK + " button disabled.": "button disabled."));
    }
  }

  return (
    <div className={'scheduler-msg-wrapper'}>
      <div className={'scheduler-msg'}>
        <div role="alert">
          {props.content}
        </div>
        <div className={'scheduler-msg-actions'}>
          <div className={"spacer"}></div>
          {props.onCancelAction && <button tabIndex={3} className={'sma-cancel three-band-focus'} onClick={props.onCancelAction}>{props.buttonLabelCancel?props.buttonLabelCancel:'Cancel'}</button> }
          <button tabIndex={2} className={'sma-schedule three-band-focus'}  onClick={handleOk}>{props.buttonLabelOK?props.buttonLabelOK:'OK'}</button>
        </div>
      </div>
    </div>
  );
}
